import {
    isSonoraPluginMeetingTimeSuggestionsEnabled,
    isSonoraMentionsPluginMeetingTimeSuggestionsEnabled,
} from './meetingTimes/isSonoraPluginMeetingTimeSuggestionsEnabled';
import {
    isSonoraPluginRichStickyNoteSuggestionsEnabled,
    isSonoraPluginRichStickyNoteViaGetItemSuggestionsEnabled,
} from './stickyNotes/isSonoraPluginStickyNoteSuggestionsEnabled';
import {
    INIT_3S_SEARCH,
    GET_MESSAGE_ITEM_BODY,
    GET_RICH_STICKY_NOTE_TEXT,
    TIME_ZONE,
    ATTENDEES,
    USE_DEBUG_MODE,
} from '../constants';
import type { KVPair } from '@augloop-types/honeybee';
import { getUserTimeZone } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import isSonoraDebugModeEnabled from './shared/isSonoraDebugModeEnabled';

export default function getPreferredSettings(isWarmup: boolean, attendees?: string) {
    const kvps: KVPair[] = [];

    kvps.push({
        key: INIT_3S_SEARCH,
        value: isWarmup.toString(),
    });

    // client side AL flighting control - to use action command
    kvps.push({
        key: 'honeybee-sonora-actionCommand',
        value: isFeatureEnabled('honeybee-sonora-actionCommand').toString(),
    });

    if (isSonoraDebugModeEnabled()) {
        kvps.push({
            key: USE_DEBUG_MODE,
            value: 'true',
        });
    }

    if (isSonoraPluginRichStickyNoteViaGetItemSuggestionsEnabled()) {
        kvps.push({
            key: GET_MESSAGE_ITEM_BODY,
            value: 'true',
        });
    } else if (isSonoraPluginRichStickyNoteSuggestionsEnabled()) {
        kvps.push({
            key: GET_RICH_STICKY_NOTE_TEXT,
            value: 'true',
        });
    }

    if (
        isSonoraPluginMeetingTimeSuggestionsEnabled() ||
        isSonoraMentionsPluginMeetingTimeSuggestionsEnabled()
    ) {
        kvps.push({
            key: TIME_ZONE,
            value: getUserTimeZone() ?? '',
        });
        !!attendees &&
            kvps.push({
                key: ATTENDEES,
                value: attendees,
            });
    }

    return kvps;
}
